// for add employee

export const RESET_EDIT_USER_PROFILE = "reset_edit_user_profile";
export const EDIT_USER_PROFILE = "edit_user_profile";
export const EDIT_USER_PROFILE_SUCCESS = "edit_user_profile_success";
export const EDIT_USER_PROFILE_FAILURE = "edit_user_profile_failure";
